import type { OnboardingOfferKey } from "@/services/api-hooks/offers";

import { track } from "../track";
import { buildOfferAnalyticsBaseParams } from "./offerAnalyticsParams";

interface Params {
  offerKey: OnboardingOfferKey;
}

export const trackOfferComplete = ({ offerKey }: Params) =>
  track({ event: "offer_complete", ...buildOfferAnalyticsBaseParams(offerKey) });
